import React from 'react'
import './Item.css'

function Item(props) {
  return (
    <div className='Item_container'>
        <div className="item_img">
            <img src={props.image} alt="" />
        </div>
        <div className="item_name">
            <p>{props.name}</p>
        </div>
        <div className="item_price">
            <p>Rs.{props.price}.00</p>
        </div>
    </div>
  )
}

export default Item